import React from 'react'

const Pie = () => {
  return (
    <div>
      
    </div>
  )
}

export default Pie
